export default __webpack_public_path__ + "static/media/meal-light-black.9eb91e83.svg";